import pages from '@/enums/pages.json';

const defaultState = {
  page: [pages.menu],
  game: {},
  cards: [],
  options: {},
  level: 0,
  time: 0,
  startTime: null,
  result: null
};

export default defaultState;
